import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import PropertyDetail from '../pages/property/page';
import BlogPage from '../pages/blog/page';
import BlogPostPage from '../pages/blogPost/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/propiedad/:slug',
    element: <PropertyDetail />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
